module.exports = __webpack_public_path__ + "media/images/products/longlife/icon-img-organizing-ac5c70b91e3454746f45798c3db7b3da.svg";